var React = require('react');

function LinkedinWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.3333 4H4.66667C4.26667 4 4 4.26667 4 4.66667V19.3333C4 19.7333 4.26667 20 4.66667 20H19.3333C19.7333 20 20 19.7333 20 19.3333V4.66667C20 4.26667 19.7333 4 19.3333 4ZM8.73333 17.6667H6.4V10H8.8V17.6667H8.73333ZM7.53333 8.93333C6.8 8.93333 6.13333 8.33333 6.13333 7.53333C6.13333 6.8 6.73333 6.13333 7.53333 6.13333C8.26667 6.13333 8.93333 6.73333 8.93333 7.53333C8.93333 8.33333 8.33333 8.93333 7.53333 8.93333ZM17.6667 17.6667H15.2667V13.9333C15.2667 13.0667 15.2667 11.9333 14.0667 11.9333C12.8 11.9333 12.6667 12.8667 12.6667 13.8667V17.6667H10.2667V10H12.5333V11.0667C12.8667 10.4667 13.6 9.86667 14.8 9.86667C17.2 9.86667 17.6667 11.4667 17.6667 13.5333V17.6667Z","fill":"white"}));
}

LinkedinWhite.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = LinkedinWhite;

LinkedinWhite.default = LinkedinWhite;
